import React from 'react';
import Button from '../../Shared/UI/Button/components/Button';

import {
  useRestrictedActionIndexState,
  useRestrictedActionIndexActions
} from './RestrictedActionIndexContext';
import RestrictedActionIndexLoader from './RestrictedActionIndexLoader';
import RestrictedActionModal from './RestrictedActionModal';

import styles from './Index.module.scss';

const RestrictedActionIndexContent = () => {
  const state = useRestrictedActionIndexState();
  const { openRestrictedActionModal } = useRestrictedActionIndexActions();

  const goToRestrictedAction = (restrictedAction) => {
    location.assign(`/restricted_actions/${restrictedAction.id}`);
  };

  return (
    <>
      <section className={styles.section}>
        <Button
          variant="primary"
          onClick={(e) => {
            e.preventDefault();
            openRestrictedActionModal();
          }}
        >
          Create Restricted Action
        </Button>
      </section>
      <section className={styles.section}>
        <h2 className={styles.tableTitle}>
          Restricted Actions
        </h2>
        {state?.restrictedActions?.length ? (
          <table id={styles.table}>
            <thead>
              <tr className={styles.tr}>
                <th className={styles.th}>Group Id</th>
                <th className={styles.th}>Restricted Action Name</th>
                <th className={styles.th}>Resource Id</th>
                <th className={styles.th}>Resource Type</th>
                <th className={styles.th}>Apply To All Users</th>
              </tr>
            </thead>
            <tbody>
              {state?.restrictedActions?.map(restrictedAction => {
                return (
                  <tr key={restrictedAction.id} className={styles.tr}>
                    <td className={styles.td}>{restrictedAction.groupId}</td>
                    <td className={styles.td}>{restrictedAction.restrictedActionName}</td>
                    <td className={styles.td}>{restrictedAction.resourceId}</td>
                    <td className={styles.td}>{restrictedAction.resourceType}</td>
                    <td className={styles.td}>{restrictedAction.applyToAllUsers.toString()}</td>
                    <td className={styles.td}>
                      <Button
                        variant="primary"
                        onClick={() => goToRestrictedAction(restrictedAction)}
                      >
                        View Details
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <p className={styles.noContentMessage}>No restricted actions.</p>
        )}
      </section>
    </>
  );
};

const Index = () => {
  return (
    <>
      <RestrictedActionIndexLoader />
      <RestrictedActionIndexContent />
      <RestrictedActionModal />
    </>
  );
};

export default Index;
